import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootCard: {
    width: '100%',
  },
  Accordion: {
    padding: '40px',
    flexDirection: 'column',
    [theme.breakpoints.down('lg')]: {
      padding: '30px 20px',
    },
    [theme.breakpoints.down('md')]: {
      padding: '30px 18px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '30px 20px',
    },
    '& .MuiIconButton-root': {
      color: theme.palette.blue2,
    },
    '& .MuiAccordionSummary-root': {
      padding: 0,
      minHeight: 0,
      maxHeight: '19px',
    },
    '& .MuiAccordionDetails-root': {
      padding: 0,
    },
  },
  container: {
    padding: '30px 40px 0',
    [theme.breakpoints.down('lg')]: {
      padding: '30px 30px 0',
    },
    [theme.breakpoints.down('md')]: {
      padding: '30px 20px 0',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '20px 20px 0',
    },
  },

  expansionPanel: {
    display: 'block',
    [theme.breakpoints.only('xs')]: {
      padding: '8px 0 8px ',
    },
  },
  roomRemaining: {
    borderRadius: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: '24px',
    marginBottom: '24px',
    maxWidth: '240px',
    padding: '16px 24px',
  },
  card: {
    '&.roomActive': {
      border: `2px solid ${theme.palette.blue2}`,
    },
    '&.roomInActive': {
      border: `2px solid ${theme.palette.grey2}`,
    },
  },
  headingRoom: {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  headingActive: {
    color: theme.palette.blue2,
  },
  headingInActive: {
    color: theme.palette.grey2,
  },
  helper: {
    textAlign: 'center',
  },

  summaryContent: {
    backgroundColor: 'white',
    padding: '0 40px 10px',
    width: '100%',
    '&.Mui-focused': {
      backgroundColor: 'white',
    },
    [theme.breakpoints.down('lg')]: {
      padding: '0 30px 10px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0 20px 10px',
    },
  },

  heading: {
    color: theme.palette.blue1,
    fontFamily: 'ProximaBold',
    fontSize: theme.typography.pxToRem(24),
    lineHeight: '150%',
    marginBottom: '20px',
  },
  fieldsContainer: {
    '& label': {
      paddingBottom: '9px',
      transform: 'unset !important',
      transition: 'unset !important',
    },
    '& legend': {
      color: theme.palette.grey9,
      '&.Mui-focused': {
        color: 'inherit',
      },
    },
    '& .MuiTextField-root': {
      '& .MuiInputBase-formControl': {
        marginTop: '25px',
      },
    },
    '& .MuiGrid-item': {
      marginTop: '34px',
      paddingLeft: '15px',
      paddingRight: '15px',

      [theme.breakpoints.down('lg')]: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
    '& .MuiGrid-item:nth-child(even)': {
      paddingRight: 0,
    },
    '& .MuiGrid-item:nth-child(odd)': {
      paddingLeft: 0,
    },
  },
  divider: {
    marginBottom: '24px',
  },
  rowContainer: {
    '& .cardNumber': {
      position: 'relative',

      '& svg': {
        width: '33px',
        height: '20px',
        right: '20px',
        position: 'absolute',
        top: '40px',
        zIndex: '1',
      },
    },
  },
  dateSelects: {
    display: 'flex',
    gap: '10px',
    '& svg': {
      fill: theme.palette.blue1,
    },
    '& .MuiFormControl-root': {
      flex: 1,
    },
    '& .MuiFormControl-root:first-child': {
      '& legend': {
        width: 125,
      },
    },
  },
  secondaryHeading: {
    color: theme.palette.blue2,
    display: 'flex',
    fontSize: theme.typography.pxToRem(14),
    textAlign: 'right',
  },
  icon: {
    height: 20,
    verticalAlign: 'bottom',
    width: 20,
  },
  pannel: {
    backgroundColor: 'white',
    boxShadow: 'none',

    '&::before': {
      display: 'none',
    },
  },

  radioButton: {
    color: theme.palette.gray2,
    marginRight: theme.typography.pxToRem(-24),
    marginLeft: theme.typography.pxToRem(16),
    position: 'absolute',
    right: '30px',
    top: '17px',
    '&.Mui-checked': {
      color: theme.palette.blue2,
    },
    [theme.breakpoints.down('sm')]: {
      top: '28px',
    },
    [theme.breakpoints.only('xs')]: {
      bottom: '34px',
    },
  },

  details: {
    color: theme.palette.blue1,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    justifyContent: 'space-between',
    position: 'relative',
    padding: '15px 30px',
    margin: '10px 0',
    minHeight: '80px',
    '&.MuiGrid-container': {
      '&:first-of-type': {
        margin: '0',
        [theme.breakpoints.only('xs')]: {
          margin: '0',
        },
      },
    },
    [theme.breakpoints.down('lg')]: {
      padding: '15px 20px',
    },
    '& .detailsTitle': {
      color: theme.palette.blue1,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '150%',
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.typography.pxToRem(14),
      },
    },

    '&:last-child': {
      marginBottom: 0,
    },
  },
  detailsTitle: {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: '150%',
    [theme.breakpoints.down('lg')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  detailsSubtitle: {
    color: theme.palette.grey1,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: '150%',
  },
  amount: {
    color: theme.palette.blue1,
    fontSize: theme.typography.pxToRem(24),
    paddingRight: '24px',
    textAlign: 'end',
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(20),
    },
    [theme.breakpoints.only('xs')]: {
      textAlign: 'left',
      paddingTop: '8px',
    },
  },
  column: {
    flexBasis: '50%',
  },
  columnLeft: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.only('xs')]: {
      flexBasis: '80%',
    },
  },
  columnRight: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      flexBasis: '20%',
    },
  },
  panelActions: {
    alignItems: 'center',
    backgroundColor: theme.palette.grey4,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    padding: '16px 24px',
    [theme.breakpoints.only('xs')]: {
      marginLeft: '-16px',
      marginRight: '-16px',
      paddingLeft: '16px',
      paddingRight: '16px',
    },
    '& .MuiButton-contained': {
      boxShadow: 'none',
    },
  },
  formLabel: {
    margin: 0,
  },

  textField: {
    color: theme.palette.blue1,
  },
  customInput: {
    paddingRight: '24px',
    textAlign: 'end',
    [theme.breakpoints.only('xs')]: {
      textAlign: 'left',
    },
    '& .MuiFormHelperText-root, & .MuiFormHelperText-root.Mui-error': {
      fontSize: theme.typography.pxToRem(10),
      textAlign: 'right',
    },
  },
  button: {
    backgroundColor: theme.palette.blue2,
    color: theme.palette.white,
    borderRadius: 3,
    textTransform: 'capitalize',
    fontSize: '18px !important',
    lineHeight: '150%',
    height: '50px',
    fontFamily: theme.typography.proxima.bold,

    [theme.breakpoints.between('sm', 'lg')]: {
      fontSize: '15px !important',
    },
    [theme.breakpoints.only('xs')]: {
      maxWidth: '100%',
      marginLeft: 0,
    },
  },
  conditionsCheck: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.only('xs')]: {
      marginLeft: '-12px',
      paddingBottom: '24px',
      paddingTop: '16px',
      width: '100%',
    },
  },
  checkboxTerms: {
    paddingLeft: 0,
    color: theme.palette.blue1,
  },
  textFieldField: {
    paddingTop: '15px !important',
    paddingBottom: '14px !important',
  },
  selectMenu: {
    maxHeight: '300px',
  },
}));

export default useStyles;
